import { Navigate, Route, Routes } from 'react-router-dom';
import EnterpriseShell from '@/components/EnterpriseShell';
import AdminPage from '@/pages/AdminPage';
import DashboardPage from '@/pages/DashboardPage';
import AssetsPage from '@/pages/AssetsPage';
import ClientBalancePage from '@/pages/ClientBalancePage';
import InventoryPage from '@/pages/InventoryPage';
import LocationsPage from '@/pages/LocationsPage';
import LoginPage from '@/pages/LoginPage';
import NotFoundPage from '@/pages/NotFoundPage';
import ReportsPage from '@/pages/ReportsPage';
import ScanPage from '@/pages/ScanPage';
import SettingsPage from '@/pages/SettingsPage';
import UsersPage from '@/pages/UsersPage';
import { useAuth } from '@/auth/AuthProvider';

function ProtectedShell() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <EnterpriseShell />;
}

function homeForRole(role: string | undefined) {
  if (role === 'Admin' || role === 'Manager') {
    return '/dashboard';
  }

  return '/scan';
}

function PublicLoginRoute() {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated) {
    return <Navigate to={homeForRole(user?.role)} replace />;
  }

  return <LoginPage />;
}

function RoleRoute({ children, allowedRoles }: { children: JSX.Element; allowedRoles: string[] }) {
  const { user } = useAuth();

  if (!user || !allowedRoles.includes(user.role)) {
    return <Navigate to={homeForRole(user?.role)} replace />;
  }

  return children;
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<PublicLoginRoute />} />
      <Route path="/login" element={<Navigate to="/" replace />} />

      <Route element={<ProtectedShell />}>
        <Route path="/dashboard" element={<RoleRoute allowedRoles={['Admin', 'Manager']}><DashboardPage /></RoleRoute>} />
        <Route path="/assets" element={<RoleRoute allowedRoles={['Admin', 'Manager']}><AssetsPage /></RoleRoute>} />
        <Route path="/clients/:clientId/balance" element={<RoleRoute allowedRoles={['Admin', 'Manager']}><ClientBalancePage /></RoleRoute>} />
        <Route path="/locations/:locationId/balance" element={<RoleRoute allowedRoles={['Admin', 'Manager']}><ClientBalancePage /></RoleRoute>} />
        <Route path="/scan" element={<ScanPage />} />
        <Route path="/locations" element={<RoleRoute allowedRoles={['Admin', 'Manager']}><LocationsPage /></RoleRoute>} />
        <Route path="/inventory" element={<InventoryPage />} />
        <Route path="/reports" element={<RoleRoute allowedRoles={['Admin', 'Manager']}><ReportsPage /></RoleRoute>} />
        <Route path="/users" element={<RoleRoute allowedRoles={['Admin', 'Manager']}><UsersPage /></RoleRoute>} />
        <Route path="/admin" element={<RoleRoute allowedRoles={['Admin']}><AdminPage /></RoleRoute>} />
        <Route path="/settings" element={<SettingsPage />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
